import { Component, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'rpfsa-app-toolbar',
	templateUrl: './app-toolbar.component.html',
	styleUrls: ['./app-toolbar.component.scss'],
})
export class AppToolbarComponent {
	@Output() sideNavToggle: EventEmitter<any> = new EventEmitter();
}
